// extracted by mini-css-extract-plugin
export default {"rowBox":"StudentsPhotosTableRow_rowBox__LrXME","studentBox":"StudentsPhotosTableRow_studentBox__dESKK","avatar":"StudentsPhotosTableRow_avatar__wm6jy"};